export const ALL_PRODUCTS = [
  {
    name: "Earth's Song",
    price: 30,
    type: 'Beanie',
    image: 'https://images.unsplash.com/photo-1772114675982-f1a85566598c?w=800&q=80',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Rasta',
    price: 30,
    type: 'Dreadlock Hat',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/xu9vhjtt_rasta.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: "Multi-color Vibin'",
    price: 30,
    type: 'Dreadlock Hat',
    image: 'https://images.unsplash.com/photo-1664488764481-31988b6d7e17?w=800&q=80',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Soul-shine',
    price: 30,
    type: 'Beanie',
    image: 'https://images.unsplash.com/photo-1616491515854-2032700c13d8?w=800&q=80',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Ocean Breeze',
    price: 30,
    type: 'Beanie',
    image: 'https://static.prod-images.emergentagent.com/jobs/d3f54f03-04a7-4e09-a47f-784beb4d2b40/images/3e1d1ca1b51ac5cd4aa5db70c6d2d2fb1bd14b209c0ac373e3bce9e60e95093c.png',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Forest Dreams',
    price: 30,
    type: 'Beanie',
    image: 'https://static.prod-images.emergentagent.com/jobs/d3f54f03-04a7-4e09-a47f-784beb4d2b40/images/5d90ab41fd21eaf2d856a015c156704054b1fd2e4b147c44f90538ff278f1237.png',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Sunset Glow',
    price: 30,
    type: 'Beanie',
    image: 'https://static.prod-images.emergentagent.com/jobs/d3f54f03-04a7-4e09-a47f-784beb4d2b40/images/8000aaf0ca64f5ee68d7d2852c9a051e382e003c043f695030f10fd3ef382cf1.png',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Summer Sun',
    price: 30,
    type: 'Sun Hat',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/gehtee3q_1000005314.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Blue Infinity Scarf',
    price: 50,
    type: 'Scarf',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/6gqlcxe1_1000005315.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/3d406e5e-086e-4b13-ab63-602'
  },
  {
    name: 'Supreme',
    price: 65,
    type: 'Premium Hat',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/t23oxvzu_1000005313.JPG',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/0d82c405-a88f-4ec3-a40c-6b3'
  },
  {
    name: 'Minty Bong Water',
    price: 30,
    type: 'Beanie',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/m8i7vfoy_minty%20bong%20water.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Raspberry Hombre',
    price: 45,
    type: 'Premium Hat',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/p89ehkp3_raspberry%20hombre.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/da4d4b77-515d-4340-a399-b62'
  },
  {
    name: 'Aurora Chevron Shawl',
    price: 100,
    type: 'Shawl',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/dyadoihp_shawl.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/07aec087-ce87-4a05-8029-d37'
  },
  {
    name: 'XL Rasta Dreadlock Tam',
    price: 60,
    type: 'Dreadlock Tam',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/mpj5uhfj_dread%20hat.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/95ce3871-40d7-4d4f-af61-661'
  },
  {
    name: 'Seasons of Joy',
    price: 30,
    type: 'Beanie',
    image: 'https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/6w54th43_joy%20of%20seasons.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/dbef2816-058d-448c-863e-d4b'
  },
  {
    name: 'Boho Rug',
    price: 90,
    type: 'Rug',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_protect-your-crown/artifacts/j1l4x5tj_Bohorug.jpg',
    paymentLink: 'https://a42f7c89-b7c9-4855-94e1-3be02f9ff2b2.paylinks.godaddy.com/5a3b9294-bf5f-4fd4-8823-933'
  }
];

export const FEATURED_PRODUCTS = [
  ALL_PRODUCTS.find(p => p.name === 'Boho Rug'),
  ALL_PRODUCTS.find(p => p.name === 'XL Rasta Dreadlock Tam'),
  ALL_PRODUCTS.find(p => p.name === 'Aurora Chevron Shawl'),
];

export const INSTAGRAM_FEED_PRODUCTS = [
  ALL_PRODUCTS.find(p => p.name === 'Boho Rug'),
  ALL_PRODUCTS.find(p => p.name === 'XL Rasta Dreadlock Tam'),
  ALL_PRODUCTS.find(p => p.name === 'Aurora Chevron Shawl'),
  ALL_PRODUCTS.find(p => p.name === 'Raspberry Hombre'),
  ALL_PRODUCTS.find(p => p.name === 'Supreme'),
  ALL_PRODUCTS.find(p => p.name === 'Minty Bong Water'),
  ALL_PRODUCTS.find(p => p.name === 'Blue Infinity Scarf'),
  ALL_PRODUCTS.find(p => p.name === 'Seasons of Joy'),
];
